import { graphql } from "react-relay";

export const COMMIT_STACK_RULE_CHANGES = graphql`
  mutation CommitStackRuleChangesMutation(
    $input: CommitStackRuleChangesInput!
  ) {
    commitStackRuleChanges(input: $input) {
      success
    }
  }
`;
